import { render, staticRenderFns } from "./TransitionPage.vue?vue&type=template&id=2be77b7e&scoped=true&"
import script from "./TransitionPage.vue?vue&type=script&lang=js&"
export * from "./TransitionPage.vue?vue&type=script&lang=js&"
import style0 from "./TransitionPage.vue?vue&type=style&index=0&id=2be77b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be77b7e",
  null
  
)

export default component.exports